import { API_URL, APP_TOKEN } from '@/constants/common';
import { isTokenExpired } from '@/lib/auth/token';
import { getFbc } from '@/lib/meta/fbc';
import { nextPageViewEventId } from '@/lib/meta/meta-event-id';

// Callers send only with marketing consent.
export const sendMetaPageView = (url: string): void => {
  // Claimed even when this call sends nothing, so a later page never reuses the entry page's ID.
  const eventId = nextPageViewEventId();
  // Also stores the click ID from the landing URL, which a visitor who moves on to /login or
  // /register before the pixel loads would otherwise lose.
  const fbc = getFbc();
  const fbp = readCookie('_fbp');
  // The API rejects an expired token with 401, even on this public route; send those as anonymous.
  const stored = readCookie('accessTokenUser');
  const token = stored && !isTokenExpired(stored) ? stored : undefined;
  if (!API_URL) return;
  // Anonymous visitors need a Meta cookie; with only IP and user agent Meta flags the event.
  // With fbc, Meta credits the PageView to the ad click as a landing page view.
  if (!token && !fbc && !fbp) return;

  fetch(`${API_URL}/meta/pageview`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'app-token': APP_TOKEN,
      ...(token && { Authorization: `Bearer ${token}` })
    },
    body: JSON.stringify({ fbp, fbc, url, eventId }),
    keepalive: true
  }).catch(() => {});
};

const readCookie = (name: string): string | undefined =>
  document.cookie
    .split('; ')
    .find((entry) => entry.startsWith(`${name}=`))
    ?.slice(name.length + 1);
